import "./Autofill.scss";
import { useHistory } from "react-router-dom";
import { defaultImg } from "../../utils/helper";

const Autofill = ({ autofillArray, clickHandler }) => {
  const history = useHistory();

  return (
    <ul
      className={`${
        history.location.pathname.length > 1
          ? "autofill__list--small"
          : "autofill__list"
      }`}
    >
      {autofillArray.map((subreddit) => {
        return (
          <li
            className="autofill__list-item"
            key={subreddit.name}
            onClick={() => clickHandler(subreddit.name, true)}
          >
            <img
              className="autofill__img"
              src={subreddit.icon === null ? defaultImg : subreddit.icon}
              onError={(e) => (e.currentTarget.src = defaultImg)}
              alt="subreddit icon"
            />
            {`r/${subreddit.name}`}
          </li>
        );
      })}
    </ul>
  );
};

export default Autofill;
